import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'
import DividerSection from '@segment/templates/DividerSection'

import Layout from '@segment/next-shared/layout'

import Resources from './components/Resources'
import Testimonial from './components/Testimonial'
import Hero from './components/Hero'
import OneAudience from './components/OneAudience'
import MaximizeReturn from './components/MaximizeReturn'
import EnrichAudiences from './components/EnrichAudiences'
import Supercharge from './components/Supercharge'

import ogImageJpg from './assets/OgImage.jpg'

const copy = {
  title: `Segment Audiences | Twilio Segment`,
  description: `Tap into the full potential of your campaigns using precise, targeted real-time audiences accessible across all platforms.`,
}

const AudienceView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={copy.title}
        pageDescription={copy.description}
        pageOG={ogImageJpg}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Hero />
        <Main>
          <OneAudience />
          <Supercharge />
          <MaximizeReturn />
          <EnrichAudiences />
          <Testimonial />
          <DividerSection />
          <Resources />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main``

export default AudienceView
